import React from "react";
import Stars from "~/common/Stars";
import { getTotalRatings } from "../../CustomerReviewHelper";
import { CustomerReviews } from "../../reviewModels";

interface ReviewsOverallRatingProps {
  reviews: CustomerReviews;
  aiSummaryText: string;
  isProductReviewPage?: boolean;
}

const ReviewsOverallRating = ({
  reviews,
  aiSummaryText,
  isProductReviewPage,
}: ReviewsOverallRatingProps) => {
  const totalReviews = getTotalRatings(reviews.productReviewDetails).length;
  const hasRating = totalReviews > 0 && reviews.overallRating > 0;

  const getAiSummaryWidthClass = () => {
    if (!aiSummaryText) {
      const widthMap = [
        isProductReviewPage
          ? "xxsl:w-1/3"
          : "xxxsl:w-1/3 xxxsl:flex xxxsl:justify-center xxxsl:items-center",
      ];
      return `md:w-1/2 ${widthMap.filter(Boolean).join(" ")}`;
    }

    return isProductReviewPage
      ? "xs:w-full md:w-1/2 flex justify-center items-center"
      : "md:w-1/2 xxxsl:w-1/3 xxxsl:flex xxxsl:justify-center xxxsl:items-center";
  };

  const aiSummaryWidthClass = getAiSummaryWidthClass();

  const baseClass = "review-rating-overall border border-solid border-gray-200";
  const productReviewPageClass =
    "w-full border-b md:border-b-0 border-r xs:border-r-0 border-l-0 border-t-0 lt:flex lt:justify-center lt:items-center px-5 xs:px-6 lt:pl-6 lt:pr-8";

  const nonProductReviewPageClass =
    "md:py-0 md:border-b-0 xxxsl:pl-0 xxxsl:pr-8 w-full border-r-0 border-l-0 border-t-0 border-b xs:px-5 py-8";

  const containerClass = `${baseClass} ${
    isProductReviewPage ? productReviewPageClass : nonProductReviewPageClass
  } ${aiSummaryWidthClass}`;

  return (
    <div className={containerClass}>
      <div className={isProductReviewPage ? "py-4 xs:py-0" : ""}>
        <p
          className={`${
            isProductReviewPage ? "text-4xl xs:text-5xl" : "text-5xl"
          } font-bold text-gray-800 mb-0`}
        >
          {hasRating ? (
            reviews.overallRating.toFixed(1)
          ) : (
            <span>Not Rated</span>
          )}
        </p>
        {hasRating && (
          <Stars
            rating={reviews.overallRating}
            size="extraLarge"
            className="py-2"
          />
        )}
        <p
          className={`${
            isProductReviewPage
              ? "text-sm xs:text-base"
              : "text-base text-gray-700"
          } m-0`}
        >
          {hasRating ? <span>{totalReviews} Customer Reviews</span> : null}
        </p>
      </div>
    </div>
  );
};

export default ReviewsOverallRating;
